/* eslint-disable import/prefer-default-export */
export { default as MainHeader } from './MainHeader';
